module.exports = __webpack_public_path__ + "img/1.2685a8e6.jpg";